export default __webpack_public_path__ + "static/media/brissa_back.f2b4a98d.bmp";